/* eslint-disable simple-import-sort/imports */
import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';

import LogoFox from 'assets/icons/logo.svg';
import routes from 'constants/routes';

import { v2 } from '../v2';

const Wrapper = styled.footer`
  position: relative;
  border-top: 1px solid ${v2.border};
  padding: 56px 0 40px;
  background: ${v2.bg};
`;

const Inner = styled.div`
  max-width: ${v2.container};
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${v2.text};

  img {
    width: 36px;
    height: 36px;
  }

  span {
    font-family: ${v2.fontDisplay};
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 2px;
  }

  small {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0;
    color: ${v2.textMuted};
    margin-left: -6px;
  }

  /* Same as the header: text group centered on the icon,
     FOXI and "abrechnung" share a baseline. */
  .brand-text {
    display: inline-flex;
    align-items: baseline;
    gap: 12px;
  }
`;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 28px;

  a {
    font-family: ${v2.fontBody};
    font-size: 14px;
    font-weight: 600;
    color: ${v2.textMuted};
    transition: color 0.25s ease;

    &:hover {
      color: ${v2.text};
    }
  }
`;

const Copyright = styled.div`
  width: 100%;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${v2.border};
  font-family: ${v2.fontBody};
  font-size: 13px;
  color: ${v2.textFaint};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
`;

const FooterV2 = () => (
  <Wrapper>
    <Inner>
      <Brand>
        <img src={LogoFox} alt="FOXI" />
        <span className="brand-text">
          <span>FOXI</span>
          <small>abrechnung</small>
        </span>
      </Brand>
      <Nav>
        <a
          href="https://www.instagram.com/foxi.abrechnung"
          target="_blank"
          rel="noreferrer"
        >
          Instagram
        </a>
        {/* <a href="mailto:info@foxi-abrechnung.de">info@foxi-abrechnung.de</a> */}
        <Link to={routes.imprint}>Impressum</Link>
        <Link to={routes.policy}>Datenschutz</Link>
      </Nav>
      <Copyright>
        <span>
          Hopf &amp; Hopf GmbH. Copyright © {new Date().getFullYear()}. Alle
          Rechte vorbehalten.
        </span>
        <span>Made in Düsseldorf</span>
      </Copyright>
    </Inner>
  </Wrapper>
);

export default FooterV2;
